// Centralized auth helpers used by every API module.
//
// localStorage key MUST stay `autobio_token` — App.js's global axios interceptor
// reads/writes the same key, and reseting it from there triggers logout on 401.
export const TOKEN_STORAGE_KEY = "autobio_token";

export function getToken() {
  return localStorage.getItem(TOKEN_STORAGE_KEY);
}

export function getAuthHeaders() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
